import { useInfiniteQueryUserLibraryTrainers } from '@ifit/gateway-wolf-athenaeum-service';
import getNextPageParam from '../get-next-page';
import { useQueryOptionsWithRowParams } from '../query-options';

export const useTrainersInfiniteQuery = () => {
  const opts = useQueryOptionsWithRowParams();
  return useInfiniteQueryUserLibraryTrainers(opts, {
    getNextPageParam,
  });
};
